import { render, staticRenderFns } from "./PdpTabs.vue?vue&type=template&id=1045afba&"
import script from "./PdpTabs.vue?vue&type=script&lang=js&"
export * from "./PdpTabs.vue?vue&type=script&lang=js&"
import style0 from "./PdpTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports